import React, { useEffect } from "react";
import { Col, Flex, Row } from "antd";
import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";
import CardComponent from "@/components/card";
import "@/styles/components/datepicker.scss";
import { getAvailableGraceTime } from "@/services/services/getAvailableGraceTime";

const RequestGraceTime = ({
  isOpen,
  message = "Grace time",
  details = {},
  onSubmit = () => {},
  onClose = () => {},
}) => {
  const handleSubmit = () => {
    onSubmit(selectedTime);
  };
  const [selectedTime, setSelectedTime] = React.useState(10);
  const [graceTimes, setGraceTimes] = React.useState([]);
  useEffect(() => {
    getAvailableGraceTime().then((res) => {
      const times = Object.values(res);
      setGraceTimes(times);
    });
  }, []);

  return (
    <ModalComponent isOpen={isOpen} width={347}>
      <Flex vertical gap="1rem" align="center">
        <div className="body-b1 text-center">{message}</div>
        <div className="date-time-picker">
          <div className="session-slots">
            <div className="slots">
              <Row gutter={[8, 8]}>
                {graceTimes.length ? (
                  graceTimes?.map((slot, index) => (
                    <Col key={index}>
                      <div
                        className={
                          slot.isBooked ? "disabled" : selectedTime === slot ? "active" : "slot"
                        }
                        onClick={() => setSelectedTime((prev) => (prev === slot ? null : slot))}
                      >
                        <CardComponent>{slot}mins</CardComponent>
                      </div>
                    </Col>
                  ))
                ) : (
                  <div style={{ textAlign: "center", width: "200px" }}>No Slot available</div>
                )}
              </Row>
            </div>
          </div>
        </div>
        <Flex gap={"1rem"}>
          <ButtonComponent
            label={details.isHost ? "Confirm Grace Time" : "Request Grace Time"}
            type="primary"
            onClick={handleSubmit}
          />
        </Flex>
      </Flex>
    </ModalComponent>
  );
};

export default RequestGraceTime;
